import "../App.css";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { useState } from "react";
import { questions } from "../Questions";
import main_Logo from "../assets/images/logo.png";
import Logo from "../assets/images/brainium.png";
import background from "../assets/images/banner-bg.jpeg";
import Logo3 from "../assets/images/leadorchard.png";
import Logo4 from "../assets/images/rishabh.png";
import Logo5 from "../assets/images/technolabs.png";
import Logo6 from "../assets/images/tinkerly.png";
import HireTalent3 from "./HireTalent3";
import { useNavigate } from "react-router-dom";
import { str } from "./slice";
import { useDispatch, useSelector } from "react-redux";

function HireTalent2() {
  const [role, setRole] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.reducerApp.strength);

  const prevButton = () => {
    navigate("/");
  };

  const nextButton = () => {
    if (data !== "") {
      navigate("/HireTalent3");
    }
  };
  const handleChange = (e, value) => {
    const type = e.target.value;
    setRole(type);
    dispatch(str(type));
  };

  const hire_talent_bg = {
    backgroundImage: `url(${background})`,
    height: "100vh",
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  };

  return (
    <>
      <div className="hire_talent_wrapper">
        <Row>
          <Col md={7} xs={12}>
            <div className="hire_talent_content">
              <Container>
                <div className="top_head text-center">
                  <img src={main_Logo} alt="Logo" />
                  <h4>Thank you for your interest in RubyPy.</h4>
                  <p>We do not yet offer top talent in India</p>
                </div>
                <Row className="card_padding">
                  <Card.Body>
                    <Form.Label className="head_title">
                      How many people are employed at your company?
                    </Form.Label>
                    <div>
                      <Form.Group controlId="1 to 5">
                        <Form.Check
                          type="radio"
                          label="1 to 5"
                          onChange={(e) => handleChange(e, e.target.value)}
                          value="1 to 5"
                          name="radioGroup"
                          checked={data === "1 to 5"}
                        />
                      </Form.Group>
                      <Form.Group controlId="More than 25 developers">
                        <Form.Check
                          type="radio"
                          label="More than 25 developers"
                          name="radioGroup"
                          onChange={(e) => handleChange(e, e.target.value)}
                          value="More than 25 developers"
                          checked={data === "More than 25 developers"}
                        />
                      </Form.Group>
                      <Form.Group controlId="Team">
                        <Form.Check
                          type="radio"
                          label="Team"
                          name="radioGroup"
                          onChange={(e) => handleChange(e, e.target.value)}
                          value="Team"
                          checked={data === "Team"}
                        />
                      </Form.Group>
                    </div>
                  </Card.Body>
                  <Card.Footer className="d-flex justify-content-between">
                    <Button onClick={prevButton}>Previous</Button>
                    <Button onClick={nextButton} disabled={data === ""}>
                      Next
                    </Button>
                  </Card.Footer>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={5} xs={12}>
            <div className="hire_talent_right_wrapper" style={hire_talent_bg}>
              <div className="hire_talent_logo">
                <div>
                  <h3>TRUSTED BY</h3>
                  <ul>
                    <li>
                      <img src={Logo} alt="fire icon" />
                    </li>
                    <li>
                      <img src={Logo3} alt="fire icon" />
                    </li>
                    <li>
                      <img src={Logo4} alt="fire icon" />
                    </li>
                    <li>
                      <img src={Logo5} alt="fire icon" />
                    </li>
                    <li>
                      <img src={Logo6} alt="fire icon" />
                    </li>
                    <li>
                      <img src={Logo} alt="fire icon" />
                    </li>
                    <li>
                      <img src={Logo3} alt="fire icon" />
                    </li>
                    <li>
                      <img src={Logo4} alt="fire icon" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default HireTalent2;
